import { render, staticRenderFns } from "./I2pu.vue?vue&type=template&id=1a0d3e03&"
import script from "./I2pu.vue?vue&type=script&lang=js&"
export * from "./I2pu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports